<template>
    <v-dialog v-model="obSearch.abrirModal" :max-width="tamModal" :scrollable="$root.isTouch == false"
        :fullscreen="$root.isTouch" persistent>
        <v-card elevation="11">
            <v-card-title class="bg-title-card">
                <span class="white--text headline" v-html="'Tipo De Servicio'"></span>
            </v-card-title>
            <v-card-text>
                <v-form ref="form_beneficio" :lazy-validation="false">
                    <v-container fluid grid-list-sm>
                        <!-- Modal -->
                        <v-row dense>
                            <v-col cols="12">
                                <v-dialog v-model="obModalTipoServicio.abrirModal" max-width="40%"
                                    :scrollable="$root.isTouch == false" :fullscreen="$root.isTouch" persistent>
                                    <v-card elevation="11">
                                        <v-card-title class="bg-title-card">
                                            <span class="white--text headline"
                                                v-html="obModalTipoServicio.titulo"></span>
                                        </v-card-title>
                                        <v-card-text>
                                            <v-form ref="form_tipo_servicio" :lazy-validation="false">
                                                <v-container fluid grid-list-sm>
                                                    <v-row dense>
                                                        <v-col cols="12">
                                                            <v-text-field label="Tipo de Servicio Complementario *"
                                                                color="textbox"
                                                                v-model="obModalTipoServicio.tipoServicioComp"
                                                                :rules="_.concat(requeridoRegla,max300Regla)" outlined
                                                                dense />
                                                        </v-col>
                                                    </v-row>
                                                    <v-row dense>
                                                        <v-col cols="12">
                                                            <v-autocomplete label="Estado *" color="textbox"
                                                                v-model="obModalTipoServicio.idEstado"
                                                                :items="_.filter(listGeneral.listEstado,{'visualiza':'true'})"
                                                                item-value="id_estado" item-text="nombre_estado"
                                                                outlined dense />
                                                        </v-col>
                                                    </v-row>
                                                    <v-row dense>
                                                        <v-col class="text-right">
                                                            <v-btn outlined rounded color="danger" class="mr-1"
                                                                @click="cerrarModal" v-html="'Cancelar'"
                                                                :disabled="disabledModal" />

                                                            <v-btn rounded dark color="primary" @click="guardarModal"
                                                                v-html="'Guardar'" :disabled="disabledModal" />
                                                        </v-col>
                                                    </v-row>
                                                </v-container>
                                            </v-form>
                                        </v-card-text>
                                    </v-card>
                                </v-dialog>
                            </v-col>
                        </v-row>
                        <!-- Fin Modal -->
                        <v-row dense>
                            <v-col class="text-right" cols="12">
                                <v-btn rounded dark color="primary" @click="add" v-html="'Nuevo'" />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-autocomplete label="Estado *" color="textbox" v-model="obSearch.idEstado"
                                    :items="listGeneral.listEstado" item-value="id_estado" item-text="nombre_estado"
                                    outlined dense />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field label="Buscar" color="textbox" v-model="obSearch.search" clearable
                                    prepend-inner-icon="search" dense />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12">
                                <v-data-table :search="obSearch.search" :headers="listGeneral.cabeceraTipoServicio"
                                    :items="listGeneral.detalleTipoServicio" class="elevation-3">

                                    <template v-slot:item.name="{ item }">
                                        <v-btn class="ma-2" text icon color="primary" @click="add(item)">
                                            <v-icon small>edit</v-icon>
                                        </v-btn>
                                    </template>

                                    <template v-slot:no-results>
                                        Tu búsqueda de "<span v-text="obSearch.search"></span>" no arrojó resultados.
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" class="text-right mt-3 mb-3">
                                <v-btn outlined rounded color="danger" class="mr-1" @click="cerrar"
                                    v-html="'Cancelar'" />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: 'ModalTipoServicioComponent',
        props: {
            obTipoServicioModal: {
                type: Object,
                default: {}
            },
            listGeneral: {
                type: Object,
                default: {}
            },
            load: {
                type: Boolean,
                default: false
            },
            parametros:{
                type: Object,
                default: {}
            }
        },
        inject:['reset','onListarTipoServicio'],
        watch: {
            load(val) {
                this.$set(this, 'obSearch', {
                    search: null,
                    abrirModal: false
                });

                if (val) {
                    this.$set(this, 'obSearch', this.obTipoServicioModal);
                    this.obSearch.idEstado = _.toString(this.parametros.id_estado_default);
                    this.onListarDetalle('L');
                }
            }
        },
        data: () => ({
            obModalTipoServicio: {
                abrirModal: false,
                titulo: null,
                idEstado:null
            },
            obSearch: {
                search: null,
                idEstado:null,
                abrirModal: false
            },
            disabledModal: false
        }),
        methods: {
            onListarDetalle(event) {
                if (!_.isUndefined(event)) {
                    var error = 'E';
                    this.listGeneral.detalleTipoServicio = [];

                    axios.post(`${BASE_URI}administrador/tipo-servicio-complementario/listar`, {
                            opcion: 'LC',
                            idEstado: _.toNumber(_.get(this.obSearch,'idEstado',0)) == 0 ? null : this.obSearch.idEstado
                        })
                        .then((r) => {
                            if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                            if (_.size(_.get(r, ['data', 'data'], [])) == 0) { error = 'I'; throw _.get(r, ['data', 'mensaje'], mensajeEstandar.errorPeticion); }
                                this.listGeneral.detalleTipoServicio = r.data.data;
                        })
                        .catch((e) => {
                            mensajesAlerta(e, error);
                        });
                }
            },
            add(objeto) {
                if (!_.isUndefined(_.get(objeto, 'idTipoServicioComp', undefined)))
                    this.$set(this, 'obModalTipoServicio', _.merge({}, this.obModalTipoServicio, objeto, {
                        opcion: 'U',
                        titulo: 'Editar Tipo De Servicio Complementario'
                    }));
                else {
                    this.obModalTipoServicio.titulo = 'Nuevo Tipo De Servicio Complementario';
                    this.obModalTipoServicio.opcion = 'I';
                    this.obModalTipoServicio.idEstado = _.toString(this.parametros.id_estado_default);
                }

                this.obModalTipoServicio.abrirModal = true;
            },
            cerrar() {
                 this.$set(this, 'obSearch', {
                    search: null,
                    abrirModal: false
                });
                this.onListarTipoServicio('L');
                this.reset({},false);
            },
            // Modal 
            cerrarModal() {
                if (!_.isUndefined(this.$refs.form_tipo_servicio))
                    this.$refs.form_tipo_servicio.resetValidation();

                this.disabledModal = false;
                this.obModalTipoServicio = {
                    abrirModal: false,
                    titulo: 'Nuevo Tipo de Servicio '
                };
            },
            guardarModal() {
                try {
                    var keys = ['opcion', 'idTipoServicioComp', 'tipoServicioComp', 'idEstado'];
                    var error = 'E';
                    this.disabledModal = true;

                    if (!this.$refs.form_tipo_servicio.validate()) throw mensajeEstandar.corregirInformacion;
                    axios.post(`${BASE_URI}administrador/tipo-servicio-complementario/insertOrUpdate`, _.pick(this
                            .obModalTipoServicio, keys))
                        .then((r) => {
                            if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                            if (_.size(_.get(r, ['data', 'data'], [])) == 0) { error = 'I'; throw _.get(r, ['data', 'mensaje'], mensajeEstandar.errorPeticion); }
                                mensajeAlertaTiempo(r.data.mensaje, 'S');
                                this.cerrarModal();
                                return this.onListarDetalle('L');
                        })
                        .catch((e) => {
                            mensajesAlerta(e, error);
                            this.disabledModal = false;
                        });
                } catch (err) {
                    mensajesAlerta(err, 'I');
                    this.disabledModal = false;
                }
            }
        }
    }
</script>